import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// Rxjs
import { of, from } from 'rxjs';
import {
  switchMap,
  map,
  catchError,
  withLatestFrom,
  take,
  tap,
  delay,
  mergeMap,
  concatMap,
} from 'rxjs/operators';
// Store
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../app.state';
// Actions
import {
  loadVersionsList,
  loadVersionsListSuccess,
  loadVersionsListFailure,
  getSelectedVersion,
  getSelectedVersionSuccess,
  getSelectedVersionFailure,
  deleteVersion,
  deleteVersionSuccess,
  deleteVersionFailure,
  addVersion,
  addVersionSuccess,
  addVersionFailure,
  editVersion,
  editVersionFailure,
  editVersionSuccess,
} from '../actions/version.actions';

// Models

// Selectors
import { setGetStatus } from '../selectors/form.selector';

// Services
import { VersionService } from '../../services/version.service';

@Injectable()
export class VersionEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private versionService: VersionService,
    private toastAlert: ToastrService
  ) {}

  loadVersionsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadVersionsList),
      //withLatestFrom(this.store.select(selectVersion)),
      concatMap(({ formId }) =>
        this.versionService.getVersions(formId).pipe(
          //tap((data:any) => {console.log('EFFECT loadVersionsList->', data)}),
          map((data: any) => loadVersionsListSuccess({ data: data })),
          catchError((error) => of(loadVersionsListFailure({ error })))
        )
      )
    )
  );

  getSelectedVersion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getSelectedVersion),
      concatMap(({ formId, version }) =>
        this.versionService.getVersion(formId, version).pipe(
          map((data: any) => getSelectedVersionSuccess({ version: data })),
          catchError((error) => of(getSelectedVersionFailure({ error })))
        )
      )
    )
  );

  DeleteVersion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteVersion),
      concatMap(({ formId, version }) =>
        this.versionService.deleteVersion(formId, version).pipe(
          map(({ content }) =>
            deleteVersionSuccess({ sk: version.sk, pk: version.pk })
          ),
          catchError((error) => of(deleteVersionFailure({ error })))
        )
      )
    )
  );

  DeleteVersionSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteVersionSuccess),
        tap((action) => {
          this.toastAlert.success(
            'Delete version was successful',
            'Delete Version'
          );
        })
      ),
    { dispatch: false }
  );

  AddVersion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addVersion),
      concatMap(({ formId }) =>
        this.versionService.addVersion(formId).pipe(
          map((data: any) => addVersionSuccess({ version: data })),
          catchError((error) => of(addVersionFailure({ error })))
        )
      )
    )
  );

  AddVersionSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addVersionSuccess),
        tap((action) => {
          this.toastAlert.success(
            'Create version was successful',
            'Create Version'
          );
        })
      ),
    { dispatch: false }
  );

  EditVersion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editVersion),
      concatMap(({ formId, version }) =>
        this.versionService.editVersion(formId, version).pipe(
          map((data: any) => editVersionSuccess({ version: data })),
          catchError((error) => of(editVersionFailure({ error })))
        )
      )
    )
  );

  EditVersionSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editVersionSuccess),
        tap((action) => {
          this.toastAlert.success('Edit version was successful', 'Edit Version');
        })
      ),
    { dispatch: false }
  );

  VersionsError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          loadVersionsListFailure,
          getSelectedVersionFailure,
          deleteVersionFailure,
          addVersionFailure,
          editVersionFailure
        ),
        tap(({ error }) => {
          const msgError = error.error || 'Internal Error ';
          this.toastAlert.error(msgError, 'Error');
        })
      ),
    { dispatch: false }
  );
}
